import React, {useCallback, useState} from "react";
import PostLoginHandler from "../handler/PostLoginHandler";
import {AccountSettings} from "../accountSettings/AccountSettings";

export default function AccountSettingsRoute(props) {

    const [pendingOperation, setPendingOperation] = useState(() => {
        try {
            const data = sessionStorage.getItem("pendingOperation");
            return data ? JSON.parse(data) : null;
        } catch {
            return null;
        }
    });

    // Once the handler finishes (or has nothing to do), fall through to the settings page.
    const handleComplete = useCallback(() => setPendingOperation(null), []);

    if (pendingOperation) {
        return <PostLoginHandler pendingOperation={pendingOperation} onComplete={handleComplete}/>;
    }

    return <AccountSettings {...props} />;
}
